var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSamples = function SvgSamples(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "samples_svg__path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "samples_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "samples_svg__export",
    transform: "translate(-256 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "samples_svg__badges/samples",
    transform: "translate(256 251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "samples_svg__Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "samples_svg__color/alexs-deep-blue/base-003595"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "samples_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#samples_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#samples_svg__path-1",
    id: "samples_svg__Mask",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("g", {
    id: "samples_svg__color/alexs-deep-blue/base-003595(og)",
    fill: "#003996",
    mask: "url(#samples_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "samples_svg__alexs-deep-blue-003595",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "samples_svg__test-tube",
    fill: "#FFF",
    fillRule: "nonzero",
    transform: "rotate(30 4.768 24.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "samples_svg__Shape",
    d: "M8.919 16.085v-14.3c.464-.028.831-.344.831-.728 0-.404-.404-.732-.9-.732H1.61c-.497 0-.861.328-.861.732 0 .384.367.7.83.729v14.3c.001 2.225 1.903 3.24 3.67 3.24s3.669-1.015 3.669-3.24m-3.703 1.918c-1.24 0-2.49-.779-2.49-2.518V2.243q-.532-.526-.374-.526H8.08q.158 0-.375.526v13.242c0 1.74-1.25 2.518-2.488 2.518"
  }), /*#__PURE__*/React.createElement("path", {
    id: "samples_svg__Shape",
    d: "M6.263 9.142c-.375 0-.713-.152-.978-.44-.693-.75-1.102-1.129-1.821-.891l-.263.085v7.46c0 1.76 1.078 2.384 2 2.384s2-.624 2-2.385V8.86l-.02.005c-.133.082-.492.278-.918.278M4.702 12.74a.5.5 0 1 1-.002-1 .5.5 0 0 1 .002 1m-.001-3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m1 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m-.5-4.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m1.5 3.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
  })))))));
};
export default SvgSamples;